<template>
  <div>
    <div class="sign-content">
      <el-card-title :title="title" class="card1" /><span
        v-if="languagezh_cn"
        style="color:red;float:left;transform: translate(339px, -18px);font-size:12px"
        >（标*为必填项）</span
      >
      <el-form
        label-width="80px"
        :rules="userFormRules"
        :model="userForm"
        ref="userFormRef1"
      >
        <el-form-item
          style="position:absolute;top:-1000;left:-1000px;opacity:0;"
        >
          <el-input type="password"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.supName')"
          label-width="350px"
          prop="supplierName"
        >
          <!--  供应商名称  -->
          <el-input
            class="egcnName"
            :placeholder="$t('page.applyUsername.inputPlc.supNameMSg')"
            v-model="userForm.supplierName"
            show-word-limit
            maxlength="300"
            v-if="localLang !== 'zh-cn'"
            @blur="changeShow()"
          ></el-input>
          <el-autocomplete
            v-if="localLang === 'zh-cn'"
            v-model="userForm.supplierName"
            :fetch-suggestions="querySearchAsync"
            :placeholder="$t('page.applyUsername.inputPlc.supNameMSg')"
            @select="handleSelect"
            :trigger-on-focus="false"
            :maxlength="100"
            @blur="changeShow()"
          >
            <!-- :disabled="isDisabled" -->
            <template slot-scope="{ item }">
              <div class="name">{{ item.name }}</div>
              <!--                <div style="font-size: 12px; color: #b4b4b4;">-->
              <!--                  <span style="width: 165px; display: inline-block">省份:{{item.base}}</span>-->
              <!--                  <span v-if="item.companyType === 1">公司类型:公司</span>-->
              <!--                  <span v-else-if="item.companyType === 2">公司类型:香港公司</span>-->
              <!--                  <span v-else-if="item.companyType === 3">公司类型:社会组织</span>-->
              <!--                  <span v-else-if="item.companyType === 4">公司类型:律所</span>-->
              <!--                  <span v-else-if="item.companyType === 5">公司类型:事业单位</span>-->
              <!--                  <span v-else-if="item.companyType === 6">公司类型:基金会</span>-->
              <!--                  </div>-->
              <!--                <div style="font-size: 12px; color: #b4b4b4;">-->
              <!--                  <span style="width: 165px; display: inline-block" >法人姓名:{{item.legalPersonName}}</span>-->
              <!--                  <span>开业时间:{{item.estiblishTime}}</span>-->
              <!--                </div>-->
              <!--                <span style="font-size: 12px; color: #b4b4b4;">注册资金:{{item.regCapital}}</span>-->
            </template>
          </el-autocomplete>
          <!-- 门户供应商注册提醒优化260119需求 改为弹框提示 -->
          <!-- <div v-if="isShow1 && localLang === 'zh-cn'" style="color:red">
            此供应商已在平台注册，如需取回账号密码，请提交取回申请(<a
              target="_blank"
              :href="clickUrl"
              >点此取回</a
            >)
          </div>
          <div v-if="isShow1 && localLang !== 'zh-cn'" style="color:red">
            This supplier has registered on the platform, if you need to
            retrieve the account password, please submit an application for
            retrieval(<a target="_blank" :href="clickUrl"
              >Click here to retrieve</a
            >)
          </div> -->
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.provinces')"
          label-width="350px"
          prop="value1"
          v-if="multilingual.areaShow[localLang]"
        >
          <!--  省市地区  -->
          <el-cascader
            v-model="userForm.value1"
            :options="userForm.options"
            :props="userForm.props"
            clearable
            ref="myCascader"
            @change="handleChange"
            :placeholder="$t('page.applyUsername.inputPlc.provincesMsg')"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.isThree')"
          label-width="350px"
          prop="isThree"
          v-if="threeZ && !isGAT"
        >
          <!-- 是否三证合一 -->
          <el-radio-group v-model="userForm.isThree" @change="changeRadio">
            <el-radio :label="1" value="是">{{
              $t("page.supInfo.inputPlc.yes")
            }}</el-radio>
            <el-radio :label="0" value="否">{{
              $t("page.supInfo.inputPlc.no")
            }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.unifyCode')"
          label-width="350px"
          v-if="isShow && !isGAT"
          prop="creditCode"
          :rules="
            !isWhite && !isHaiwaiorGAT
              ? userFormRules.creditCode
              : userFormRules.creditCode2
          "
          ref="isShowRef"
          key="isShowRef12"
        >
          <!-- 统一社会信用代码 -->
          <el-input
            :placeholder="$t('page.supInfo.inputPlc.unifyCode')"
            v-model="userForm.creditCode"
            show-word-limit
            maxlength="18"
            :disabled="!isWhite && !isHaiwaiorGAT"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.GATunifyCode')"
          label-width="350px"
          v-if="isGAT"
          prop="creditCode"
          :rules="userFormRules.GATcreditCode"
          key="isShowRef10"
          ref="isShowRef"
          class="endItem"
        >
          <!-- 港澳台统一社会信用代码 -->
          <el-input
            :placeholder="$t('page.supInfo.inputPlc.GATunifyCode')"
            v-model="userForm.creditCode"
            show-word-limit
            maxlength="75"
            class="GATcreditCode"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="营业执照号:"
          label-width="350px"
          v-if="isThreeShow && threeZ"
          prop="business"
          ref="isThreeShowRef5"
        >
          <el-input
            placeholder="请输入营业执照号"
            v-model="userForm.business"
            show-word-limit
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.framework')"
          label-width="350px"
          v-if="isThreeShow && threeZ"
          prop="organizingInstitution"
          :rules="
            languagezh_cn && !isWhite && !isHaiwaiorGAT
              ? [{ required: false }]
              : userFormRules.organizingInstitution
          "
          ref="isThreeShowRef1"
        >
          <!-- 组织机构代码 -->
          <el-input
            :placeholder="$t('page.supInfo.inputPlc.framework')"
            v-model="userForm.organizingInstitution"
            show-word-limit
            maxlength="18"
            :disabled="!isWhite && !isHaiwaiorGAT"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.organization')"
          label-width="350px"
          required
          v-if="isThreeShow && threeZ"
          class="validity"
        >
          <!-- 组织机构代码证件有效期 -->
          <el-col :span="5">
            <el-form-item prop="date3" ref="isThreeShowRef2">
              <el-date-picker
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :placeholder="$t('page.supInfo.inputPlc.chooseDate')"
                v-model="userForm.date3"
                :picker-options="pickerOptions1"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="5">
            <el-form-item prop="date4" ref="isThreeShowRef3">
              <el-date-picker
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :placeholder="$t('page.supInfo.inputPlc.chooseDate')"
                v-model="userForm.date4"
                :picker-options="pickerOptions2"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item
          :label="$t('page.supInfo.contentLabel.dutyParagraph')"
          label-width="350px"
          v-if="isThreeShow && threeZ"
          prop="dutyParagraph"
          :rules="
            languagezh_cn && !isWhite && !isHaiwaiorGAT
              ? [{ required: false }]
              : userFormRules.dutyParagraph
          "
          ref="isThreeShowRef4"
        >
          <!-- 税号 -->
          <el-input
            :placeholder="$t('page.supInfo.inputPlc.dutyParagraph')"
            v-model="userForm.dutyParagraph"
            maxlength="25"
            :disabled="!isWhite && !isHaiwaiorGAT"
          ></el-input>
        </el-form-item>
        <!--<el-form-item :label="$t('page.applyUsername.contentLabel.id')" label-width="350px" prop="loginId" v-show="disabledLoginId" >     &lt;!&ndash;  登录账号  &ndash;&gt;-->
        <!--<el-input :placeholder="$t('page.applyUsername.inputPlc.idMsg')" v-model="userForm.loginId" :disabled="isDisabled"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item
          v-if="languagezh_cn"
          label="登录账号:"
          label-width="350px"
          prop="userName"
          class="userMobile"
        >
          <el-input
            placeholder="请输入登录账号"
            maxlength="50"
            v-model="userForm.userName"
            :disabled="isDisabled"
          ></el-input>
          <!--            <div class="el-block" v-if="!isLogin">-->
          <!--              <div class="slideText1" v-if="slideShow">请按住滑块，拖到最右边</div>-->
          <!--              <div class="slideText2" v-else>已验证</div>-->
          <!--              <div class="el-block-replace">&nbsp;</div>-->
          <!--              <el-slider v-model="value11" @change="sliderChange" :disabled="sliderDisabled">-->
          <!--              </el-slider>-->
          <!--            </div>-->
        </el-form-item>
        <el-form-item
          label="Username:"
          v-else
          label-width="350px"
          prop="userName"
          class="userMobile"
        >
          <el-input
            placeholder="Please enter your username"
            v-model="userForm.userName"
            maxlength="50"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.pwd')"
          label-width="350px"
          prop="password"
          ref="passwordRef"
        >
          <!--  密码  -->
          <el-input
            :placeholder="$t('page.applyUsername.inputPlc.pwdMsg')"
            v-model="userForm.password"
            type="password"
            autocomplete="noneoff"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.repwd')"
          label-width="350px"
          prop="rePassword"
        >
          <!--  重复输入密码  -->
          <el-input
            :placeholder="$t('page.applyUsername.inputPlc.repwdMsg')"
            v-model="userForm.rePassword"
            type="password"
            autocomplete="noneoff"
            :disabled="isDisabled"
          ></el-input>
        </el-form-item>
      </el-form>
      <el-card-title :title="title1" class="card2" />
      <el-form
        label-width="80px"
        :model="linkmanForm"
        :rules="linkmanFormRules"
        ref="userFormRef2"
        :class="{ enForm: !languagezh_cn }"
      >
        <div :class="multilingual.contactsTip[localLang]">
          {{ $t("page.applyUsername.contentTitles.contactsWay") }}
        </div>
        <!--  固定电话、手机和E-mail为重要联系方式，请务必认真填写  -->
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.contacts')"
          label-width="350px"
          prop="linkMan"
        >
          <!--  联系人  -->
          <el-input
            :placeholder="$t('page.applyUsername.inputPlc.contactsMsg')"
            v-model="linkmanForm.linkMan"
            maxlength="25"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.contactsTel')"
          label-width="350px"
          prop="telePhone"
        >
          <!--  联系人固定电话  -->
          <el-input
            :placeholder="$t('page.applyUsername.inputPlc.contactsTelMsg')"
            v-model="linkmanForm.telePhone"
            maxlength="25"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('page.applyUsername.contentLabel.contactsFax')"
          label-width="350px"
        >
          <!--  联系人传真  -->
          <el-input
            :placeholder="$t('page.applyUsername.inputPlc.contactsFaxMsg')"
            v-model="linkmanForm.facSimile"
            maxlength="25"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="isChinese === 'zh-cn'"
          label="手机号归属地："
          label-width="350px"
          prop="isOverseaMobile"
          ><!--手机号归属地-->
          <el-select
            style="width: 430px; margin-left: 6px;"
            class="IDplac"
            v-model="linkmanForm.isOverseaMobile"
          >
            <el-option label="中国" :value="0"> </el-option>
            <el-option label="海外" :value="1"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="isChinese === 'zh-cn'"
          :label="$t('page.applyUsername.contentLabel.contactsMobile')"
          label-width="350px"
          :prop="isChinese === 'zh-cn' ? 'userMobile' : ''"
          :rules="
            linkmanForm.isOverseaMobile === 1
              ? linkmanFormRules.userMobileOverSea
              : linkmanFormRules.userMobile
          "
        >
          <div
            style="
              display: flex;
              width: 430px;
              /* align-items: self-end; */
              justify-content: space-between;
            "
          >
            <!--  联系人手机  -->
            <el-input
              style="margin-right: 5px"
              :placeholder="$t('page.applyUsername.inputPlc.contactsMobileMsg')"
              v-model="linkmanForm.userMobile"
              show-word-limit
              :maxlength="
                linkmanForm.isOverseaMobile === 1
                  ? multilingual.userMobile['en-gb']
                  : multilingual.userMobile['zh-cn']
              "
            ></el-input>
            <el-button @click="sendCode" :disabled="isSend"
              ><span v-if="isSend">{{ countDown }}秒后</span
              >发送验证码</el-button
            >
            <div class="islider" v-if="isCode">
              <Slider
                @close="
                  isCode = false;
                  isSend = false;
                "
                :log="true"
                @getImg="getImg"
                @validImg="validImg"
              ></Slider>
            </div>
          </div>
          <span style="color: red;">{{
              "提示：2分钟内同一手机号不可重复获取验证码"
            }}</span>
        </el-form-item>
        <el-form-item
          v-else
          :label="$t('page.applyUsername.contentLabel.contactsMobile')"
          label-width="350px"
          :prop="isChinese === 'zh-cn' ? 'mobile' : ''"
        >
          <!--  联系人手机 (英文) -->
          <el-input
            style="margin-right: 5px"
            :placeholder="$t('page.applyUsername.inputPlc.contactsMobileMsg')"
            v-model="userForm.contactMobile"
            show-word-limit
            :maxlength="multilingual.userMobile[localLang]"
            :disabled="isChinese === 'zh-cn' ? true : false"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          label-width="356px"
          v-if="!isLogin && languagezh_cn"
          class="formSlide"
        >
          <machineCheck
            key="sms-slider"
            @ncData="ncData"
            id="sms-slider"
            :isEnabled="isEnabled"
          ></machineCheck>
        </el-form-item> -->
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.authCode')"
          label-width="350px"
          prop="authCode"
          class="authCode"
          v-if="!isLogin && languagezh_cn"
        >
          <!--  验证码  -->
          <el-input
            :placeholder="$t('page.applyUsername.inputPlc.authCodeMsg')"
            v-model="linkmanForm.authCode"
            autocomplete="noneoff"
          ></el-input>
          <!-- <el-button
            type="primary"
            :disabled="codeDisabled"
            @click="getCode"
            class="codeBtn"
            v-show="show"
            :class="{ enBtn: !languagezh_cn }"
            >{{ $t("page.applyUsername.btn.getCode") }}</el-button
          > -->
          <!-- <el-button
            type="primary"
            @click="getCode"
            class="count"
            v-show="!show"
            :disabled="timeDisabled"
            >{{ count }}</el-button
          > -->
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.contactsEmail')"
          label-width="350px"
          prop="email"
        >
          <div
            style="
              display: flex;
              /* align-items: self-end; */
              justify-content: space-between;
            "
          >
            <!--  联系人E-mail  -->
            <el-input
              style="margin-right: 5px"
              :placeholder="$t('page.applyUsername.inputPlc.contactsEmailMsg')"
              v-model="linkmanForm.email"
              maxlength="320"
            ></el-input>
            <!-- 发送验证码 -->
            <el-button v-if="!isLogin && !languagezh_cn" class="codeBtn" :class="{ enBtn: !languagezh_cn }" @click="sendEmailCode" :disabled="isSendEmail"
              ><span v-if="isSendEmail">{{ countDown }} </span
              >{{ $t("page.validateEmail.title4") }}</el-button
            >
            <div class="islider" v-if="!isLogin && !languagezh_cn && isCode">
              <Slider
                @close="
                  isCode = false;
                  isSendEmail = false;
                "
                :log="true"
                @getImg="getImg"
                @validImg="validImg"
              ></Slider>
            </div>
          </div>
        </el-form-item>
        <!-- <el-form-item
          label-width="356px"
          v-if="!isLogin && !languagezh_cn"
          class="formSlide"
        >
          <machineCheck
            key="sms-slider"
            @ncData="ncData"
            id="sms-slider"
            :isEnabled="isEnabled"
          ></machineCheck>
        </el-form-item> -->
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.authCode')"
          label-width="350px"
          prop="authCode"
          class="authCode"
          v-if="!isLogin && !languagezh_cn"
        >
            <!--  验证码  -->
            <el-input
              :placeholder="$t('page.applyUsername.inputPlc.authCodeMsg')"
              v-model="linkmanForm.authCode"
              autocomplete="noneoff"
            ></el-input>
            <!-- <el-button
              type="primary"
              :disabled="codeDisabled"
              @click="getEmailCode"
              class="codeBtn"
              v-show="show"
              :class="{ enBtn: !languagezh_cn }"
              >{{ $t("page.applyUsername.btn.getCode") }}</el-button
            >
            <el-button
              type="primary"
              @click="getCode"
              class="count"
              v-show="!show"
              :disabled="timeDisabled"
              >{{ count }}</el-button
            > -->
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.type')"
          label-width="350px"
          prop="certType"
          v-if="languagezh_cn"
        >
          <!--  证件类型  -->
          <el-select
            style="width: 430px; margin-left: 6px;"
            class="IDplac"
            v-model="linkmanForm.certType"
          >
            <el-option
              :label="$t('page.applyUsername.others.IDCard')"
              :value="1"
            >
            </el-option>
            <el-option
              :label="$t('page.applyUsername.others.aboardIDCard')"
              :value="2"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('page.applyUsername.contentLabel.ID')"
          label-width="350px"
          prop="contactIdcard"
          :rules="linkmanForm.certType === 2 ? linkmanFormRules.contactIdcardOverSea : linkmanFormRules.contactIdcard"
          v-if="languagezh_cn"
        >
          <!--  证件号  -->
          <el-input
            class="IDplac"
            :placeholder="$t('page.applyUsername.inputPlc.IDMsg')"
            v-model="linkmanForm.contactIdcard"
            show-word-limit
            maxlength="18"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item
          v-if="linkmanForm.certType === 1 && isChinese === 'zh-cn'"
          style="height: auto;"
          :label="$t('page.applyUsername.contentLabel.IDFront')"
          label-width="350px"
          prop="positiveImageUrl"
        >
          <IDCardValidate
            style="margin-left: 6px;"
            :imageUrl="linkmanForm.positiveImageUrl"
            :exampleImg="require('@/assets/images/back.png')"
            @setUploadImageUrl="setUploadImageUrl($event, 'positiveImageUrl')"
          />
        </el-form-item>
        <el-form-item
          v-if="linkmanForm.certType === 1 && isChinese === 'zh-cn'"
          style="height: auto;"
          :label="$t('page.applyUsername.contentLabel.IDBack')"
          label-width="350px"
          prop="negativeImageUrl"
        >
          <IDCardValidate
            style="margin-left: 6px;"
            :imageUrl="linkmanForm.negativeImageUrl"
            :exampleImg="require('@/assets/images/front.png')"
            @setUploadImageUrl="setUploadImageUrl($event, 'negativeImageUrl')"
          />
        </el-form-item> -->
        <div class="recommendUnitGroup">
          <el-card-title
            :title="title2"
            class="card3"
            :class="{ encard: !languagezh_cn }"
          />
          <!--      <recommendUnits></recommendUnits>-->
          <div :class="multilingual.reCompanyTitleClass[localLang]">
            {{ $t("page.applyUsername.contentTitles.reCompanyMsg") }}
          </div>
          <el-form-item
            :label="$t('page.applyUsername.contentLabel.reCompany')"
            label-width="350px"
            prop="reCompany"
            class="reCompany"
          >
            <el-input
              :placeholder="$t('page.applyUsername.inputPlc.reCompanyMsg')"
              v-model.trim="linkmanForm.reCompany"
              @focus="$refs.choosePartyA.showDialogInventory()"
              :readonly="true"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="btnBox">
      <el-button
        class="left-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="back()"
      >
        <span>{{ $t("basicLayout.btn")[0] }}</span>
      </el-button>
      <el-button
        class="right-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="next()"
      >
        <span>{{ $t("basicLayout.btn")[1] }}</span>
      </el-button>
    </div>
    <!-- 下一步弹层 -->
    <el-dialog
      :title="$t('page.applyUsername.dialogMsg.title')"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <span
        >{{ $t("page.applyUsername.dialogMsg.msg1") }}“{{
          linkmanForm.reCompany + "（" + linkmanForm.orgFullName + "）"
        }}”{{ $t("page.applyUsername.dialogMsg.msg2") }}</span
      >
      <!-- 您现在选择的推荐单位是“”，推荐单位负责审核您公司的注册信息。请仔细核对，避免出错！-->
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >{{ $t("page.productInfo.btn.cancel") }}</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="confirmNext">{{
          $t("page.productInfo.btn.confirm")
        }}</el-button>
      </span>
    </el-dialog>
    
    <!-- 新加下一步弹层 -->
    <el-dialog
      :title="$t('page.applyUsername.dialogMsg.title')"
      :visible.sync="dialogNewVisible"
      width="600px"
    >
      <span
        style="color: #FF142F;"
      >{{ $t("page.applyUsername.dialogMsg.msg3") }}</span>
      <!-- 系统将为您保留注册信息 72 小时；若超时未提交注册申请，系统将自动删除相关注册数据（删除后不可恢复）-->
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogNewVisible = false"
          >{{ $t("page.productInfo.btn.cancel") }}</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="confirmNewNext">{{
          $t("page.productInfo.btn.confirm")
        }}</el-button>
      </span>
    </el-dialog>
    <choosePartyA
      ref="choosePartyA"
      :selectedTitle="languagezh_cn ? '已选择单位' : 'Selected unit'"
      :title="languagezh_cn ? '请选择单位' : 'Please select a unit'"
      mode="radio"
      :isselectedData="partyASelectedNode"
      :requestTreeFunction="queryRecommendedUnitTree"
      :requestSeachFunction="queryMemberGroup"
      @selectedStaffSuccess="selectPartyA"
    />
    <!-- 推荐单位 弹框 -->
    <el-dialog
      v-if="isRecommendedUnitTreeShow"
      :visible.sync="dialogRecommendedUnitTree"
      title="选择推荐单位"
      width="600px"
      append-to-body
      :before-close="beforeClose"
    >
      <div class="left-trrr" style="min-height:500px;">
        <div class="tree-box">
          <el-tree
            ref="tree"
            :props="defaultProps"
            :load="recommendedUnitLoadNode"
            node-key="companyId"
            lazy
            :check-strictly="true"
            show-checkbox
            @check="getCheckedNodes"
            @check-change="getCurrentNode"
          >
          </el-tree>
        </div>
      </div>
      <div size="mini" type="default-mini" slot="footer" class="dialog-footer">
        <el-button size="mini" type="default-mini" @click="closeDialog"
          >取消</el-button
        >
        <el-button size="mini" type="primary-font-mini" @click="confirmForm"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 门户供应商注册提醒优化260119 改为弹框提示 -->
    <el-dialog
      class="prompt"
      title=""
      :visible.sync="dialogPrompt"
      width="35%"
      append-to-body
      :before-close="beforePromptClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div v-if="promptType == 'RP_SP0001'" class="dialog-content">
        <h3 class="title">{{ promptTitle }}</h3>
        <p class="desc">{{ promptContent }}</p>
      </div>
      <div v-if="promptType == 'RP_SP0001_000001'" class="dialog-content">
        <p class="desc">{{ promptContent1 }}</p>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleForgot">{{ promptbutton1 }}</el-button>
        <el-button type="primary" @click="handleLoginOne">{{ promptbutton2 }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import recommendUnits from "./recommendUnits";
import { addUrlPerFix } from "@/utils";
import {
  AddressRegionList,
  AddressByCodeRegionList,
  createSupplierAccount,
  qrySupRegistAccountInfo,
  //checkRecommendOrg,
  saveSupplierRegistInfo,
  checkSuppilerInfo,
  sendVerificationCode,
  checkSendEmailCode,
  checkContactByMobile,
  qryTycSearch,
  qrySupTycInfo,
  checkMobileVerificationCode,
  checkEmailVerificationCode,
  queryMemberGroup,
  queryRecommendedUnitTree,
  qryIdCardByHwOcr,
  getImageVerifyCode   // 获取图形验证码接口
} from "@/api/supRegister";
import { qrySupWhiteListBySupName } from "@/api/supRegister";
import validators from "../../../../utils/validators";
import debounce from "@/utils/index";
import Setting from "@/config/index";
import Cookies from "js-cookie";
const savedLocaleKey = Setting.i18n.cookieLable;
import { mapActions } from "vuex";
import zhCN from "../../../../i18n/locale/zh-CN";
import layoutLocale from "../../../../i18n/locale/layoutLocaleI18n";
import enUS from "../../../../i18n/locale/en-US";
import esEs from "../../../../i18n/locale/es-ES";
import faFR from "../../../../i18n/locale/fa-FR";
import elsRU from "../../../../i18n/locale/els-RU";
import albAR from "../../../../i18n/locale/alb-AR";
import choosePartyA from "../components/staffSelector";
import machineCheck from "../components/no-captcha";
import IDCardValidate from "../components/IDCardValidate.vue";
import Slider from "./slider";

export default {
  name: "applyUsername",
  components: {
    machineCheck,
    choosePartyA,
    IDCardValidate,
    Slider  // 2025-12-06 手机号获取验证码修改
  },
  data() {
    // 查询推荐单位
    // const checkUnit = (rule, value, callback) => {
    //   if (!value) {
    //     callback(new Error(window.$t('page.applyUsername.inputRules.reCompanyMsg')));  //推荐单位不能为空
    //   }else {
    // checkRecommendOrg({
    //   isOverseas: '0',
    //   recommendCompanyName: value
    // }).then((res)=>{
    //   if(res.data.code === '0') {
    //     if(res.data.data.existsFlag === '1' && res.data.data.topFlag === '0'){
    //       this.linkmanForm.recommendIndyId = res.data.data.recommendOrgInfoBO.companyId
    //       this.linkmanForm.recommendIndyCode = res.data.data.autoCode
    //       callback()
    //     }else{
    //       if(res.data.data.existsFlag === '0') {
    //         callback(new Error(window.$t('page.applyUsername.inputRules.reCompanyMsg1')));  // 推荐单位不存在
    //       } else if (res.data.data.topFlag === '1') {
    //         callback(new Error(window.$t('page.applyUsername.inputRules.reCompanyMsg2'))); // 请输入非集团总部单位
    //       }
    //     }
    //   } else {
    //     callback(new Error(window.$t('page.applyUsername.inputRules.reCompanyMsg'))); // 推荐单位不存在
    //   }
    // })
    // }
    // };
    return {
      tycInfo: JSON.stringify({}),
      isShow1: false,
      isWhite: false,
      isHaiwaiorGAT: false,
      partyASelectedNode: [],
      clickUrl: `${addUrlPerFix("sp.iccec.cn")}/retrievePassword`,
      title: window.$t("page.applyUsername.contentTitle.loginInfo"), // 登陆账号和密码
      title1: window.$t("page.applyUsername.contentTitle.contacts"), // 联系人和联系方式
      title2: window.$t("page.applyUsername.contentTitle.reCompany"), // 推荐单位
      // 门户供应商注册提醒优化260119 改为弹框提示
      dialogPrompt: false,
      promptType: "",
      promptTitle: window.$t("page.applyUsername.contentTitle.promptTitle"),
      promptContent: window.$t("page.applyUsername.contentTitle.promptContent"),
      promptContent1: window.$t("page.applyUsername.contentTitle.promptContent1"),
      promptbutton1: window.$t("page.applyUsername.btn.promptbutton1"),
      promptbutton2: window.$t("page.applyUsername.btn.promptbutton2"),
      multilingual: Object.freeze({
        userMobile: {
          undefined: 11,
          "zh-cn": 11,
          "en-gb": "50",
          "es-es": "", // 西班牙语
          "fr-fr": "",
          "ru-ru": "",
          ar: ""
        },
        reCompanyTitleClass: {
          undefined: "reCompanyTitle",
          "zh-cn": "reCompanyTitle",
          "en-gb": "reCompanyTitle_en",
          "es-es": "reCompanyTitle_en", // 西班牙语
          "fr-fr": "reCompanyTitle_en",
          "ru-ru": "reCompanyTitle_en",
          ar: "reCompanyTitle_en"
        },
        contactsTip: {
          undefined: "grouptips",
          "zh-cn": "grouptips",
          "en-gb": "grouptips_en",
          "es-es": "grouptips_en", // 西班牙语
          "fr-fr": "grouptips_en",
          "ru-ru": "grouptips_en",
          ar: "grouptips_en"
        },
        areaShow: {
          undefined: true,
          "zh-cn": true,
          "en-gb": false,
          "es-es": false, // 西班牙语
          "fr-fr": false,
          "ru-ru": false,
          ar: false
        }
      }),
      localLang: Cookies.get(savedLocaleKey) || "zh-cn",
      isLogin: false,
      labelPosition: "right",
      isShow: false,
      isThreeShow: false,
      isDisabled: false,
      value11: 0,
      disabledLoginId: false,
      existFlag: "",
      codeDisabled: true,
      sliderDisabled: false,
      show: true,
      count: "",
      timer: null,
      timeDisabled: true,
      slideShow: true,
      threeZ: "", // 是否展示三证合一
      isGAT: false, //是否港澳台
      // 表单数据
      userForm: {
        supplierName: "",
        loginId: "",
        authCode: "",
        userName: "",
        password: "",
        rePassword: "",
        isThree: "",
        creditCode: "",
        business: "",
        organizingInstitution: "",
        date3: "",
        date4: "",
        dutyParagraph: "",
        userMobile: "",
        isOverseas: 0,
        contactMobile: "",
        props: {
          checkStrictly: true,
          expandTrigger: "hover", // 鼠标滑过展开
          lazy: true,
          lazyLoad(node, resolve) {
            console.log(node, "lazyLoad");
            if (node.level === 0) {
              AddressRegionList({ parentCode: "" }).then(response => {
                let cities = response.data.data.map((value, i) => ({
                  value: value.addressCode,
                  label: value.addressName,
                  leaf: false
                }));
                cities.forEach(res => {
                  res.disabled = true;
                });
                resolve(cities);
              });
            } else if (
              node.label == "港澳台" &&
              node.level >= 1 &&
              node.level < 3
            ) {
              AddressByCodeRegionList({ addressCode: node.data.value }).then(
                response => {
                  let areas = response.data.data.map((value, i) => ({
                    value: value.addressCode,
                    label: value.addressName,
                    leaf: !(value.lastFlag === 0) || node.level === 3
                  }));
                  if (node.level == 1) {
                    areas.forEach(res => {
                      res.disabled = true;
                    });
                  } else if (node.level == 2) {
                    //广东东莞、中山、海南儋州只用选到第三级
                    res.data.data.forEach(res => {
                      if (
                        res.parentCode != 110 &&
                        res.parentCode != 121 &&
                        res.parentCode != 143 &&
                        res.addressCode != 441900 &&
                        res.addressCode != 442000 &&
                        res.addressCode != 460400
                      ) {
                        res.disabled = true;
                      }
                    });
                  }
                  areas.map(item => {
                    if (node.label == "港澳台") {
                      item.leaf = item.lastFlag === 0;
                    } else {
                      item.leaf = item.lastFlag === 1;
                    }
                  });
                  resolve(areas);
                }
              );
            } else if (node.level >= 1 && node.level < 4) {
              AddressByCodeRegionList({ addressCode: node.data.value }).then(
                response => {
                  let areas = response.data.data.map((value, i) => ({
                    value: value.addressCode,
                    label: value.addressName,
                    parentCode: value.parentCode,
                    leaf: !(value.lastFlag === 0) || node.level === 3
                  }));
                  if (node.level == 1) {
                    areas.forEach(res => {
                      res.disabled = true;
                    });
                  } else if (node.level == 2) {
                    //广东东莞、中山、海南儋州只用选到第三级
                    areas.forEach(obj => {
                      if (
                        obj.parentCode != 110 &&
                        obj.parentCode != 121 &&
                        obj.parentCode != 143 &&
                        obj.label != "东莞市" &&
                        obj.label != "中山市" &&
                        obj.label != "儋州市"
                      ) {
                        obj.disabled = true;
                      }
                    });
                  }
                  resolve(areas);
                }
              );
            }
          }
        },
        value1: [],
        options: [],
        factCapl: ""
      },
      linkmanForm: {
        linkMan: "",
        authode: "",
        telePhone: "",
        facSimile: "",
        mobile: "",
        userMobile: "",
        email: "",
        contactIdcard: "",
        certType: "",
        reCompany: "",
        recommendIndyId: "",
        recommendIndyCode: "",
        provinces: "",
        positiveImageUrl: "",
        negativeImageUrl: "",
        isOverseaMobile: 0,
        value: []
      },
      fileInfoList: [],
      idCardIsMatched: false,
      // 表单验证规则
      userFormRules: {},
      linkmanFormRules: {
        linkMan: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.contactsMsg"),
            trigger: "blur"
          }
          // {validator:validators.userName,message:window.$t('page.applyUsername.inputRules.contactsMsg')},
        ],
        telePhone: [
          {
            required: false,
            message: window.$t("page.applyUsername.inputPlc.contactsTelMsg"),
            trigger: "blur"
          },
          {
            pattern: /^((0\d{2,3})-)?(\d{7,8})(-(\d{3,}))?$/,
            message: window.$t("page.applyUsername.inputRules.contactsTelMsg"),
            trigger: "blur"
          }
        ],
        facSimile: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.contactsFaxMsg"),
            trigger: "blur"
          },
          {
            pattern: /^(\d{3,4}-)?\d{7,8}$/,
            message: window.$t("page.applyUsername.inputRules.contactsFaxMsg"),
            trigger: "blur"
          }
        ],
        // mobile: [{ required: true, message: window.$t('page.applyUsername.inputPlc.contactsMobileMsg'), trigger: 'blur' },
        //   {pattern: /^1[34578]\d{9}$/, message: window.$t('page.applyUsername.inputRules.contactsMobileMsg')}],
        email: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.contactsEmailMsg"),
            trigger: "blur"
          },
          {
            pattern: /\@/,
            message: window.$t(
              "page.applyUsername.inputRules.contactsEmailMsg"
            ),
            trigger: "blur"
          },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: window.$t(
              "page.applyUsername.inputRules.contactsEmailMsg"
            ),
            trigger: "blur"
          }
        ],
        reCompany: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputRules.reCompanyMsg"),
            trigger: ["blur", "change"]
          }
        ],
        userMobile: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.contactsMobileMsg"),
            trigger: ["blur", "change"]
          },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: window.$t("page.contactInfo.inputRules.mobileMsg"),
            trigger: "blur"
          }
        ],
        userMobileOverSea: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.contactsMobileMsg"),
            trigger: ["blur", "change"]
          }
        ],
        authCode: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputRules.codemsg "),
            trigger: "blur"
          }
        ],
        contactIdcard: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.IDMsg"),
            trigger: "blur"
          },
          {
            required: true,
            pattern: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}([0-9Xx])$/,
            message: window.$t("page.applyUsername.inputPlc.IDMSGValidate"),
            trigger: "blur"
          }
        ],
        contactIdcardOverSea: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.IDMsg"),
            trigger: "blur"
          }
        ],
        certType: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.cerType"),
            trigger: "blur"
          }
        ],
        positiveImageUrl: [
          {
            required: true,
            message: "请上传身份证国徽面"
          }
        ],
        negativeImageUrl: [
          {
            required: true,
            message: "请上传身份证人像面"
          }
        ],
        isOverseaMobile: [
          {
            required: true,
            message: "请选择联系人手机号归属地",
            trigger: "change"
          }
        ]
      },
      dialogVisible: false,
      dialogNewVisible: false,
      supInfoApplyId: "",
      supNameList: [],
      timeout: null,
      isSkyEyes: false, // 是否天眼查
      tempSupinfoId: "",
      isEnabled: 0,
      isChinese: Cookies.get(savedLocaleKey) || "zh-cn",
      isRecommendedUnitTreeShow: false,
      dialogRecommendedUnitTree: false,
      defaultProps: {
        label: "companyName",
        //children: "child",
        isLeaf: "leaf"
      },
      // 是否勾选了节点
      checkedFlag: false,
      companyId: "",

      // 2025-12-06 手机号获取验证码修改
      isSend: false,
      countDown: 120,
      isCode: false,
      //  2025-12-11 email获取验证码修改
      isSendEmail: false,
      isEmailCode: false,
    };
  },
  computed: {
    pickerOptions1() {
      let that = this;
      return {
        disabledDate: function(time) {
          if (that.userForm.date4) {
            return time.getTime() > new Date(that.userForm.date4).getTime();
          } else {
            return false;
          }
        }
      };
    },
    pickerOptions2() {
      let that = this;
      return {
        disabledDate: function(time) {
          if (that.userForm.date3) {
            return time.getTime() < new Date(that.userForm.date3).getTime();
          } else {
            return false;
          }
        }
      };
    }
  },
  watch: {
    "linkmanForm.contactIdcard"(newValue, oldValue) {
      this.linkmanForm.contactIdcard = newValue.replace(/[\W]/g, "");
    }
  },
  created() {
    if (this.$route.query.isChangeInfo) {
      this.isDisabled = true;
    }
    if (this.$route.query.page) {
      this.changeCheckPage(3);
    }
    if (
      Cookies.get(savedLocaleKey) === undefined ||
      Cookies.get(savedLocaleKey) === "zh-cn"
    ) {
      this.threeZ = true;
      this.userForm.isThree = 1;
      this.isShow = true;
    } else {
      this.threeZ = false;
      this.isShow = false;
      this.isThreeShow = false;
      this.linkmanFormRules.telePhone = [];
      this.linkmanFormRules.facSimile = [];
    }
    if (this.$route.query.tempSupinfoId) {
      this.isLogin = true;
      this.userFormRules = {
        supplierName: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.supNameMSg"),
            trigger: "blur"
          }
        ],
        isThree: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.choose"),
            trigger: "change"
          }
        ],
        value1: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.provincesMsg"),
            trigger: "change"
          }
        ],
        creditCode: [
          {
            required: window.languagezh_cn ? false : true,
            message: window.$t("page.supInfo.inputPlc.unifyCode"),
            trigger: "blur"
          },
          {
            pattern: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur"
          },
          {
            max: 18,
            min: 18,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur"
          }
        ],
        creditCode2: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.unifyCode"),
            trigger: "blur"
          },
          {
            pattern: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur"
          },
          {
            max: 18,
            min: 18,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur"
          }
        ],
        GATcreditCode: [
          {
            required: true,
            message: "请输入港澳台统一代码证",
            trigger: "blur"
          },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: "请输入正确的港澳台统一代码证",
            trigger: "blur"
          }
        ],

        business: [
          { required: true, message: "请输入营业执照号", trigger: "blur" },
          {
            pattern: /[1-9]\d/,
            message: "请输入正确的营业执照号",
            trigger: "blur"
          },
          { min: 15, message: "不能小于15位", trigger: "blur" }
        ],
        organizingInstitution: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.framework"),
            trigger: "blur"
          }
        ],
        date3: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.chooseDate"),
            trigger: "change"
          }
        ],
        date4: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.chooseDate"),
            trigger: "change"
          }
        ],
        dutyParagraph: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.dutyParagraph"),
            trigger: "blur"
          }
        ],
        userName: [
          {
            required: true,
            message: window.languagezh_cn
              ? "请输入登录账号"
              : "Please enter your username",
            trigger: "blur"
          },
          {
            pattern: /(^([a-zA-Z]*)$)|(^((?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]*)$)/,
            message: window.languagezh_cn
              ? "请输入登录账号，支持字母或字母数字组合"
              : "Only enter letters or alphanumeric combinations!",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.pwdMsg"),
            trigger: "blur"
          }
        ],
        rePassword: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.repwdMsg"),
            trigger: "blur"
          }
        ],
        loginId: [
          { required: true, message: "请输入登录账号", trigger: "blur" }
        ]
      };
      this.getSupRegistAccountInfo();
    } else {
      this.userFormRules = {
        supplierName: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.supNameMSg"),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  new Error(
                    window.$t("page.applyUsername.inputRules.supNameMSg")
                  )
                ); // 供应商名称不能为空
              } else {
                setTimeout(() => {
                  this.isShow1 = false;
                  checkSuppilerInfo({
                    supName: this.userForm.supplierName,
                    isOverseas:
                      Cookies.get(savedLocaleKey) === undefined ||
                      Cookies.get(savedLocaleKey) === "zh-cn"
                        ? 0
                        : 1
                  }).then(res => {
                    console.log(res);
                    if (res.data.data === "NO_SP0001") {
                      this.isShow1 = true;
                      this.qrySupWhiteListBySupName(this.userForm.supplierName);
                      // callback(new Error(window.$t('page.applyUsername.inputRules.supNameMSg1'))) // 该供应商名称已存在
                    } else if (res.data.data === "RP_SP0001") {
                      this.isShow1 = true;
                      this.promptType = res.data.data;
                      this.dialogPrompt = true;
                      this.qrySupWhiteListBySupName(this.userForm.supplierName);
                      // callback(new Error(window.$t('page.applyUsername.inputRules.supNameMSg1'))) // 该供应商名称已存在
                    } else if(res.data.data === "RP_SP0001_000001") {  // 针对于审批退回的供应商
                      this.promptType = res.data.data;
                      this.dialogPrompt = true;
                    } else if(['RP_SP0241','RP_SP0242','RP_SP0243', "RP_SP00074"].includes(res.data.data)){
                      callback(new Error(res.data.message))
                    } else {
                      this.isShow1 = false;
                      callback();
                      this.qrySupWhiteListBySupName(this.userForm.supplierName);
                    }
                  });
                }, 100);
              }
            },
            trigger: "blur"
          }
        ],
        isThree: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.choose"),
            trigger: "change"
          }
        ],
        value1: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.provincesMsg"),
            trigger: "change"
          }
        ],
        creditCode: [
          {
            required: window.languagezh_cn ? false : true,
            message: window.$t("page.supInfo.inputPlc.unifyCode"),
            trigger: "blur"
          },
          {
            pattern: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur"
          },
          {
            max: 18,
            min: 18,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("统一社会信用代码不能为空"));
              } else {
                checkSuppilerInfo({
                  regNum: value
                }).then(res => {
                  console.log(res);
                  if (res.data.data === "RP_SP0033") {
                    callback(new Error("该统一社会信用代码已存在"));
                  } else {
                    callback();
                  }
                });
              }
            },
            trigger: "blur"
          }
        ],
        creditCode2: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.unifyCode"),
            trigger: "blur"
          },
          {
            pattern: /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur"
          },
          {
            max: 18,
            min: 18,
            message: "请输入正确的统一社会信用代码",
            trigger: "blur"
          }
        ],
        GATcreditCode: [
          {
            required: true,
            message: "请输入港澳台统一代码证",
            trigger: "blur"
          },
          {
            pattern: /^[^\u4e00-\u9fa5]+$/,
            message: "请输入正确的港澳台统一代码证",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("港澳台统一代码证不能为空"));
              } else {
                checkSuppilerInfo({
                  regNum: value
                }).then(res => {
                  console.log(res);
                  if (res.data.data === "RP_SP0033") {
                    callback(new Error("该港澳台统一代码证已存在"));
                  } else {
                    callback();
                  }
                });
              }
            },
            trigger: "blur"
          }
        ],
        business: [
          { required: true, message: "请输入营业执照号", trigger: "blur" },
          {
            pattern: /[0-9]\d/,
            message: "请输入正确的营业执照号",
            trigger: "blur"
          },
          { min: 15, message: "不能小于15位", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("营业执照号不能为空"));
              } else {
                checkSuppilerInfo({
                  regNum: value
                }).then(res => {
                  console.log(res);
                  if (res.data.data === "RP_SP0033") {
                    callback(new Error("该营业执照号已存在"));
                  } else {
                    callback();
                  }
                });
              }
            },
            trigger: "blur"
          }
        ],
        organizingInstitution: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.framework"),
            trigger: "blur"
          }
        ],
        date3: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.chooseDate"),
            trigger: "change"
          }
        ],
        date4: [
          {
            required: true,
            message: window.$t("page.supInfo.inputRules.chooseDate"),
            trigger: "change"
          }
        ],
        dutyParagraph: [
          {
            required: true,
            message: window.$t("page.supInfo.inputPlc.dutyParagraph"),
            trigger: "blur"
          }
        ],
        // loginId: [{ required: true, message: window.$t('page.applyUsername.inputPlc.idMsg'), trigger: 'blur' },
        //   {min:2,max:8,message:window.$t('page.applyUsername.inputRules.idMsg1')},
        //   { pattern:/^[A-Za-z0-9_]{2,8}$/, message: window.$t('page.applyUsername.inputRules.idMsg2')}],
        userMobile: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.contactsMobileMsg"),
            trigger: "blur"
          },
          {
            pattern:
              (Cookies.get(savedLocaleKey) === "zh-cn") === undefined ||
              Cookies.get(savedLocaleKey) === "zh-cn"
                ? /^1[3456789]\d{9}$/
                : "",
            message: window.$t(
              "page.applyUsername.inputRules.contactsMobileMsg"
            ),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  new Error(
                    window.$t("page.applyUsername.inputRules.mobilemsg")
                  )
                ); // 手机号不能为空
              } else {
                checkSuppilerInfo({
                  registMobile: value
                }).then(res => {
                  console.log(res);
                  if (res.data.data === "RP_SP0002") {
                    callback(
                      new Error(
                        window.$t("page.applyUsername.inputRules.mobilemsg1")
                      )
                    ); // 该手机号已存在
                  } else {
                    callback();
                  }
                });
              }
            },
            trigger: "blur"
          }
        ],
        userName: [
          {
            required: true,
            message: window.languagezh_cn
              ? "请输入登录账号"
              : "Please enter your username",
            trigger: "blur"
          },
          {
            pattern: /(^([a-zA-Z]*)$)|(^((?!([a-zA-Z]+|\d+)$)[a-zA-Z\d]*)$)/,
            message: window.languagezh_cn
              ? "请输入登录账号，支持字母或字母数字组合"
              : "Only enter letters or alphanumeric combinations!",
            trigger: "blur"
          }
        ],
        authCode: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.authCodeMsg"),
            trigger: "blur"
          }
          // {validator:(rule, value, callback) => {
          //     if (!value) {
          //       callback(new Error('验证码不能为空'));
          //     }else {
          //       checkContactByMobile({
          //         mobile: this.userForm.userMobile,
          //         inputAuthCode: value
          //       }).then((res)=>{
          //         console.log(res)
          //         if(res.data.code === '200') {
          //           callback(new Error('验证码错误'))
          //         } else {
          //           callback()
          //         }
          //       })
          //     }
          //   },trigger: 'blur'}
        ],
        password: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.pwdMsg"),
            trigger: "blur"
          },
          {
            min: 8,
            max: 16,
            message: window.$t("page.applyUsername.inputRules.pwdMsg1")
          },
          {
            pattern: /(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[^a-zA-Z0-9]).{8,16}/,
            message: window.$t("page.applyUsername.inputRules.pwdMsg2"),
            trigger: "blur"
          }
        ],
        rePassword: [
          {
            required: true,
            message: window.$t("page.applyUsername.inputPlc.repwdMsg"),
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("请输入密码"));
              } else if (value !== this.userForm.password) {
                callback(
                  new Error(window.$t("page.applyUsername.inputRules.repwdMsg"))
                );
              } else {
                callback();
              }
            },
            message: window.$t("page.applyUsername.inputRules.repwdMsg"),
            trigger: "blur"
          }
        ]
      };
    }
  },
  mounted() {},
  methods: {
    ...mapActions(["changeCheckPage"]),
    queryMemberGroup,
    queryRecommendedUnitTree,
    back() {
      this.changeCheckPage(2);
      this.$router.push({
        path: "/maPerfectInfo/moralAgreement",
        query: {
          tempSupinfoId: this.$route.query.tempSupinfoId
            ? this.$route.query.tempSupinfoId
            : this.tempSupinfoId,
          tempOrFormalFlag: this.$route.query.tempOrFormalFlag
        }
      });
    },
    next() {
      if (
        Cookies.get(savedLocaleKey) === undefined ||
        Cookies.get(savedLocaleKey) === "zh-cn"
      ) {
        if (this.userForm.isThree === 0) {
          this.isShow = false;
          this.isThreeShow = true;
        } else if (this.userForm.isThree === 1) {
          this.isThreeShow = false;
          this.isShow = true;
        }
      } else {
        this.isShow = false;
        this.isThreeShow = false;
      }
      const rule1 = new Promise((resolve, reject) => {
        this.$refs.userFormRef1.validate(valid => {
          if (valid) {
            resolve();
          } else {
            setTimeout(() => {
              const isError = document.getElementsByClassName("is-error");
              isError[0].querySelector("input").focus();
              isError[0].scrollIntoView({
                behavior: "smooth",
                block: "center"
              });
            }, 100);
            return false;
          }
        });
      });
      const rule2 = new Promise((resolve, reject) => {
        this.$refs.userFormRef2.validate(valid => {
          if (valid) {
            resolve();
          } else {
            setTimeout(() => {
              const isError = document.getElementsByClassName("is-error");
              isError[0].querySelector("input").focus();
            }, 100);
            return false;
          }
        });
      });
      Promise.all([rule1, rule2]).then(async () => {
        // if(!Cookies.get('111')) {
        //   checkContactByMobile({
        //     mobile: this.userForm.userMobile,
        //     inputAuthCode: this.userForm.authCode
        //   }).then(res => {
        //     if(res.data.code === '0') {
        //       this.dialogVisible = true
        //     } else {
        //       this.$message.error('验证码错误')
        //     }
        //   })
        // } else {
        //   this.dialogVisible = true
        // }
        let codeAuth = false;
        if (!this.isLogin && !this.linkmanForm.authCode) {
          this.$message({
            showClose: true,
            type: "error",
            message: window.languagezh_cn
              ? "请输入验证码"
              : "Please enter the verification code",
            ccuiCustom: true
          });
          return;
        }
        // const validateIDCard = this.validateIDCard();
        // if (!validateIDCard) return;
        if (window.languagezh_cn && !this.isLogin) {
          await checkMobileVerificationCode({
            phoneNumber: this.linkmanForm.userMobile,
            verificationCode: this.linkmanForm.authCode,
            isShowLoading: true
          }).then(res => {
            codeAuth = true;
          });
        } else if (!this.isLogin) {
          await checkEmailVerificationCode({
            email: this.linkmanForm.email,
            verificationCode: this.linkmanForm.authCode,
            isShowLoading: true
          }).then(res => {
            codeAuth = true;
          });
        }
        this.dialogVisible = true;
      });
    },
    selectPartyA([data]) {
      this.companyId = data.companyId;
      this.linkmanForm.recommendIndyId = data.companyId;
      this.linkmanForm.recommendIndyCode = data.autoCode;
      this.linkmanForm.reCompany = window.languagezh_cn
        ? data.companyName
        : data.companyEnName;
      this.linkmanForm.orgFullName = data.orgFullName;
    },
    changeShow() {
      if (!this.userForm.supplierName) {
        this.isShow1 = false;
      }
    },
    removehtmlTags(text) {
      return text.replace(/<[^>]+>/g, "");
    },
    changeRadio(val) {
      if (val === 0) {
        this.isShow = false;
        this.isThreeShow = true;
        this.$refs.isShowRef.clearValidate();
      } else if (val === 1) {
        this.isThreeShow = false;
        this.isShow = true;
        this.$refs.isThreeShowRef1 &&
          this.$refs.isThreeShowRef1.clearValidate();
        this.$refs.isThreeShowRef2 &&
          this.$refs.isThreeShowRef2.clearValidate();
        this.$refs.isThreeShowRef3 &&
          this.$refs.isThreeShowRef3.clearValidate();
        this.$refs.isThreeShowRef4 &&
          this.$refs.isThreeShowRef4.clearValidate();
        this.$refs.isThreeShowRef5 &&
          this.$refs.isThreeShowRef5.clearValidate();
      }
    },
    // 省市地区列表
    handleChange(val) {
      if (val.length > 2) {
        if (
          val[2] == "441900" ||
          val[2] == "442000" ||
          val[2] == "44200" ||
          val.length == 4
        ) {
          this.$refs.myCascader.dropDownVisible = false;
        }
        if (val[0] == "970000") {
          //港澳台
          this.$refs.myCascader.dropDownVisible = false;
          this.isGAT = true;
          this.isThree = 1;
          this.changeRadio(1);
        } else {
          this.isGAT = false;
        }
        if (val[0] == "980000" || val[0] == "970000") {
          this.isHaiwaiorGAT = true;
        } else {
          this.isHaiwaiorGAT = false;
        }
      }
      setTimeout(() => {
        this.$nextTick(() => {
          this.getLabelValue();
        });
      }, 1);
    },
    qrySupWhiteListBySupName(supName) {
      qrySupWhiteListBySupName({
        supName: supName
      }).then(obj => {
        if (obj.data.data.rows.length > 0) {
          this.isWhite = true;
        } else {
          this.isWhite = false;
        }
      });
    },
    getLabelValue() {
      this.userForm.locationCode = "";
      this.userForm.provinceCode = "";
      this.userForm.cityCode = "";
      this.userForm.countyCode = "";
      const obj = this.$refs["myCascader"].getCheckedNodes();
      console.log(obj);
      // this.linkmanForm.country = obj[0].pathLabels[0];
      this.userForm.locationCode = obj[0].path[0];
      this.userForm.provinceCode = obj[0].path[1];
      this.userForm.cityCode = obj[0].path[2];
      // this.userForm.countyCode = JSON.stringify(obj[0].path);
      this.userForm.countyCode = obj[0].path[3];
      this.userForm.locationName = obj[0].pathLabels[0];
      this.userForm.provinceName = obj[0].pathLabels[1];
      this.userForm.cityName = obj[0].pathLabels[2];
      this.userForm.countyName = obj[0].pathLabels[3];
      console.log(this.userForm.locationCode);
      console.log(this.userForm.provinceCode);
      console.log(this.userForm.cityCode);
      console.log(this.userForm.countyCode);
    },
    confirmNext() {
      this.dialogVisible = false;
      this.dialogNewVisible = true;
    },
    // 确定下一步
    async confirmNewNext() {
      sessionStorage.setItem("countyCode", this.userForm.countyCode);
      sessionStorage.setItem("countyName", this.userForm.countyName);
      this.dialogNewVisible = false;
      if (this.existFlag) {
        saveSupplierRegistInfo({
          dataSourceFlag: 0,
          isOverseas:
            Cookies.get(savedLocaleKey) === undefined ||
            Cookies.get(savedLocaleKey) === "zh-cn"
              ? 0
              : 1,
          saveOrCommitFlag: "2",
          supRegistTab: "4",
          tycInfo: this.tycInfo,
          tempSupinfoId: this.supInfoApplyId,
          supRegistAccountInfoBO: {
            dataSourceFlag: 0,
            isCredentials: this.isGAT ? 1 : this.userForm.isThree,
            supName: this.userForm.supplierName,
            recommendIndyId: this.linkmanForm.recommendIndyId,
            recommendIndyCode: this.linkmanForm.recommendIndyCode,
            recommendIndyName: this.linkmanForm.reCompany,
            regNum:
              this.userForm.isThree === 1
                ? this.userForm.creditCode
                : this.userForm.business,
            orgCode:
              this.userForm.isThree === 1
                ? ""
                : this.userForm.organizingInstitution,
            orgCredentialsStart:
              this.userForm.isThree === 1 ? "" : this.userForm.date3,
            orgCredentialsEnd:
              this.userForm.isThree === 1 ? "" : this.userForm.date4,
            taxCode:
              this.userForm.isThree === 1 ? "" : this.userForm.dutyParagraph,
            locationCode: this.userForm.locationCode,
            provinceCode: this.userForm.provinceCode,
            cityCode: this.userForm.cityCode,
            countyCode: this.userForm.countyCode,
            locationName: this.userForm.locationName,
            provinceName: this.userForm.provinceName,
            cityName: this.userForm.cityName,
            countyName: this.userForm.countyName,
            registAccountContactInfoBO: {
              contactName: this.linkmanForm.linkMan,
              contactMobile:
                this.isChinese === "zh-cn"
                  ? this.linkmanForm.userMobile
                  : this.userForm.contactMobile,
              contactTel: this.linkmanForm.telePhone,
              contactFax: this.linkmanForm.facSimile,
              contactEmail: this.linkmanForm.email,
              contactIdcard: this.linkmanForm.contactIdcard,
              certType: this.linkmanForm.certType,
              fileInfoList: this.fileInfoList,
              positiveImageUrl: this.linkmanForm.positiveImageUrl,
              negativeImageUrl: this.linkmanForm.negativeImageUrl,
              isOverseaMobile: this.linkmanForm.isOverseaMobile
            }
          },
          isShowLoading: true
        }).then(res => {
          this.changeCheckPage(4);
          this.$router.push({
            path: "/maPerfectInfo/basicInformation",
            query: {
              tempSupinfoId: this.$route.query.tempSupinfoId
                ? this.$route.query.tempSupinfoId
                : this.tempSupinfoId,
              tempOrFormalFlag: this.$route.query.tempOrFormalFlag
            }
          });
        });
        return false;
      }

      createSupplierAccount({
        dataSourceFlag: 0,
        isOverseas:
          Cookies.get(savedLocaleKey) === undefined ||
          Cookies.get(savedLocaleKey) === "zh-cn"
            ? 0
            : 1,
        supName: this.userForm.supplierName,
        // userName: this.userForm.userMobile,
        isShowLoading: true,
        registMobile: this.userForm.userMobile,
        userPwd: this.userForm.password,
        userName: this.userForm.userName,
        isCredentials: this.isGAT
          ? 1
          : Cookies.get(savedLocaleKey) === undefined ||
            Cookies.get(savedLocaleKey) === "zh-cn"
          ? this.userForm.isThree
          : 0,
        regNum:
          this.userForm.isThree === 1
            ? this.userForm.creditCode
            : this.userForm.business,
        orgCode:
          this.userForm.isThree === 1
            ? ""
            : this.userForm.organizingInstitution,
        orgCredentialsStart:
          this.userForm.isThree === 1 ? "" : this.userForm.date3,
        orgCredentialsEnd:
          this.userForm.isThree === 1 ? "" : this.userForm.date4,
        taxCode: this.userForm.isThree === 1 ? "" : this.userForm.dutyParagraph,
        recommendIndyId: this.linkmanForm.recommendIndyId,
        recommendIndyCode: this.linkmanForm.recommendIndyCode,
        factCaplFlag: this.userForm.factCapl ? 0 : 1,
        tycInfo: this.tycInfo,
        factCapl: this.userForm.factCapl,
        recommendIndyName: this.linkmanForm.reCompany,
        locationCode: this.userForm.locationCode,
        provinceCode: this.userForm.provinceCode,
        cityCode: this.userForm.cityCode,
        countyCode: this.userForm.countyCode,
        locationName: this.userForm.locationName,
        provinceName: this.userForm.provinceName,
        cityName: this.userForm.cityName,
        countyName: this.userForm.countyName,
        operIpAddress: "10.88.201.31",
        registContactInfoBO: {
          contactName: this.linkmanForm.linkMan,
          contactMobile:
            this.isChinese === "zh-cn"
              ? this.linkmanForm.userMobile
              : this.userForm.contactMobile,
          contactTel: this.linkmanForm.telePhone,
          contactFax: this.linkmanForm.facSimile,
          contactEmail: this.linkmanForm.email,
          contactIdcard: this.linkmanForm.contactIdcard,
          certType: this.linkmanForm.certType,
          fileInfoList: this.fileInfoList,
          positiveImageUrl: this.linkmanForm.positiveImageUrl,
          negativeImageUrl: this.linkmanForm.negativeImageUrl,
          isOverseaMobile: this.linkmanForm.isOverseaMobile
        }
      }).then(res => {
        if (res.data.code == 0) {
          this.$message({
            type: "success",
            duration: 3000,
            message:
              this.localLang == "zh-cn"
                ? "将生成账号信息，请注意留存账号、密码等重要信息（账号信息已同步发至联系人邮箱）！"
                : "An account will be generated, please note and keep the important account information (the account information has been synchronized to the contact's email address)!"
          });
          setTimeout(() => {
            this.changeCheckPage(4);
            this.tempSupinfoId = res.data.data.tempSupinfoId;
            this.$router.push({
              path: "/maPerfectInfo/basicInformation",
              query: { tempSupinfoId: this.tempSupinfoId }
            });
          }, 3000);
        }
      });
    },
    // 获取注册申请用户信息
    async getSupRegistAccountInfo() {
      const { data } = await qrySupRegistAccountInfo({
        tempOrFormalFlag: this.$route.query.tempOrFormalFlag
          ? this.$route.query.tempOrFormalFlag
          : 0,
        supInfoApplyId: this.$route.query.tempSupinfoId,
        isShowLoading: true
      });
      if (data.code === "0") {
        this.qrySupWhiteListBySupName(data.data.supRegistAccountInfoBO.supName);
        const res = data.data.supRegistAccountInfoBO;
        this.tycInfo = res.tycInfo;
        this.userForm.supplierName = res.supName;
        this.userForm.supCode = res.supCode;
        this.userForm.loginId = res.registMobile;
        this.userForm.userMobile = res.registMobile;
        this.linkmanForm.userMobile =
          res.registAccountContactInfoBO.contactMobile;
        this.userForm.password = res.userPwd;
        this.linkmanForm.orgFullName = data.data.orgFullName;
        this.userForm.userName = res.userName;
        this.userForm.rePassword = res.userPwd;
        this.userForm.isThree = res.isCredentials;
        if (res.isCredentials === 0) {
          this.userForm.business = res.regNum;
          this.userForm.organizingInstitution = res.orgCode;
          this.userForm.date3 = res.orgCredentialsStart;
          this.userForm.date4 = res.orgCredentialsEnd;
          this.userForm.dutyParagraph = res.taxCode;
          this.isShow = false;
          this.isThreeShow = true;
        } else if (res.isCredentials === 1) {
          this.userForm.creditCode = res.regNum;
          this.isThreeShow = false;
          this.isShow = true;
        }
        this.linkmanForm.linkMan = res.registAccountContactInfoBO.contactName;
        this.userForm.contactMobile =
          res.registAccountContactInfoBO.contactMobile;
        this.linkmanForm.telePhone = res.registAccountContactInfoBO.contactTel;
        this.linkmanForm.facSimile = res.registAccountContactInfoBO.contactFax;
        this.linkmanForm.mobile = res.registAccountContactInfoBO.contactMobile;
        this.linkmanForm.email = res.registAccountContactInfoBO.contactEmail;
        this.linkmanForm.contactIdcard =
          res.registAccountContactInfoBO.contactIdcard;
        this.linkmanForm.reCompany = res.recommendIndyName;
        this.userForm.locationName = res.locationName;
        this.userForm.locationCode = res.locationCode;
        this.userForm.provinceName = res.provinceName;
        this.userForm.provinceCode = res.provinceCode;
        this.userForm.cityName = res.cityName;
        this.userForm.cityCode = res.cityCode;
        this.userForm.countyName = res.countyName;
        this.userForm.countyCode = res.countyCode;
        this.existFlag = data.data.existFlag;
        this.supInfoApplyId = data.data.supInfoApplyId;
        this.userForm.value1 = [
          res.locationCode,
          res.provinceCode,
          res.cityCode,
          res.countyCode
        ];
        if (res.locationName) {
          this.$refs.myCascader.inputValue = res.locationName;
        }
        if (res.provinceName) {
          this.$refs.myCascader.inputValue =
            this.$refs.myCascader.inputValue + "/" + res.provinceName;
        }
        if (res.cityName) {
          this.$refs.myCascader.inputValue =
            this.$refs.myCascader.inputValue + "/" + res.cityName;
        }
        if (res.countyName) {
          this.$refs.myCascader.inputValue =
            this.$refs.myCascader.inputValue + "/" + res.countyName;
        }
        if (this.$route.query.tempSupinfoId) {
          this.disabledLoginId = true;
          this.isDisabled = true;
        }
        if (res.locationCode == "970000") {
          this.isGAT = true;
        }
        if (res.locationCode == "980000" || res.locationCode == "970000") {
          this.isHaiwaiorGAT = true;
        } else {
          this.isHaiwaiorGAT = false;
        }
        this.linkmanForm.certType = res.registAccountContactInfoBO.certType;
        // if (this.linkmanForm.certType === 1) {
        //   this.idCardIsMatched = true;
        //   this.linkmanForm.positiveImageUrl =
        //     res.registAccountContactInfoBO.positiveImageUrl;
        //   this.linkmanForm.negativeImageUrl =
        //     res.registAccountContactInfoBO.negativeImageUrl;
        // }
        this.linkmanForm.isOverseaMobile =
          res.registAccountContactInfoBO.isOverseaMobile;
      }
    },
    // 滑块改变
    // sliderChange() {
    //   if(this.userForm.userMobile === '') {
    //     this.$message.error('请先输入手机号')
    //     this.value11 = 0
    //   } else {
    //     if(this.value11 === 0) {
    //       this.codeDisabled = true
    //     } else if (this.value11>0&&this.value11<100) {
    //       this.codeDisabled = true
    //       this.value11 = 0
    //     } else if (this.value11 === 100) {
    //       this.codeDisabled = false
    //       this.sliderDisabled = true
    //       this.slideShow = false
    //     }
    //   }
    // },
    // 获取验证码
    getCode() {
      sendVerificationCode({
        phoneNumbers:
          this.isChinese === "zh-cn"
            ? this.linkmanForm.userMobile
            : this.userForm.contactMobile
      }).then(res => {
        console.log(res);
        if (res.data.code === "0") {
          this.$message.success("短信验证码发送成功，请注意接收");
        }
      });
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    getEmailCode() {
      checkSendEmailCode({
        email: this.linkmanForm.email
      }).then(res => {
        console.log(res);
        if (res.data.code === "0") {
          this.$message.success(
            "Email verification code sent successfully, please note receiving"
          );
        }
      });
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    // 天眼查
    querySearchAsync(queryString, callback) {
      if (queryString) {
        qryTycSearch({
          companyName: queryString
        }).then(res => {
          res.data.data.forEach(obj => {
            // obj.name=this.removehtmlTags(obj.name)
            obj.name = obj.companyName;
          });
          if (res.data.code === "0") {
            this.tycInfo = JSON.stringify({});
            this.userForm.creditCode = "";
            this.userForm.business = "";
            this.userForm.organizingInstitution = "";
            this.userForm.dutyParagraph = "";
            this.userForm.value1 = [];
            this.userForm.date4 = "";
            this.userForm.date3 = "";
            this.userForm.factCapl = "";
            this.userForm.creditCode = "";
            this.isGAT = false;
            if (res.data.data.length === 0) {
              this.$message({
                showClose: true,
                message: res.data.message,
                type: "info",
                ccuiCustom: true
              });
            }
            this.supNameList = res.data.data;
            // if(this.supNameList.length==0){
            //   this.userForm.creditCode = ""
            //   this.userForm.business = ""
            //   this.userForm.organizingInstitution = ""
            //   this.userForm.dutyParagraph = ""
            //   this.userForm.value1=[]
            //   this.userForm.date4=""
            //   this.userForm.date3=""
            //   this.userForm.factCapl=""
            //   this.isGAT=false
            //   // this.tycInfo = JSON.stringify({})
            // }
            let results = this.supNameList;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              callback(results);
            }, 100 * Math.random());
          }
        });
      }
    },
    // 选择供应商名称输入的数据
    handleSelect(item) {
      console.log(item);
      if (item) {
        this.userForm.supplierName = item.name;
        qrySupTycInfo({
          companyName: item.name,
          creditCode: item.creditCode
        }).then(res => {
          console.log(res);
          if (res.data.code === "0") {
            this.isWhite = res.data.data.isWhite == 1;
            res.data.data = res.data.data.supTycInfoBO;
            this.userForm.creditCode = res.data.data.creditCode;
            this.userForm.business = res.data.data.regNum;
            this.userForm.organizingInstitution = res.data.data.orgCode;
            this.userForm.dutyParagraph = res.data.data.taxCode;
            this.userForm.value1 = [];
            this.userForm.date4 = "";
            this.userForm.date3 = "";
            this.userForm.factCapl = res.data.data.factCapl;
            this.isGAT = false;
            this.$refs.myCascader.inputValue = "";
            // this.tycInfo = {"busiScope":res.data.data.busiScope,"businessEnd":res.data.data.businessEnd,"businessStart":res.data.data.businessStart,"companyType":res.data.data.companyType,"companyTypeName":res.data.data.companyTypeName,"creditCode":res.data.data.creditCode,"factCapl":res.data.data.factCapl,"foundTime":res.data.data.foundTime,
            // "homeAddr":res.data.data.homeAddr,"legalContactName":res.data.data.legalContactName,"moneyType":res.data.data.moneyType,"moneyTypeName":res.data.data.moneyTypeName,"orgCode":res.data.data.orgCode,"regCapl":res.data.data.regCapl,"regNum":res.data.data.regNum,"supName":res.data.data.supName,"supShort":res.data.data.supShort,"taxCode":res.data.data.taxCode}
            this.tycInfo = JSON.stringify(res.data.data)
            this.userFormRules = { ...this.userFormRules, supplierName: [{ required: true, message: window.$t('page.applyUsername.inputPlc.supNameMSg'), trigger: 'blur' },
                {validator:(rule, value, callback) => {
                    if (!value) {
                      callback(new Error(window.$t('page.applyUsername.inputRules.supNameMSg'))); // 供应商名称不能为空
                    }else {
                      setTimeout(()=>{
                        this.isShow1 = false
                        checkSuppilerInfo({
                          regNum: res.data.data.creditCode,
                          supName: this.userForm.supplierName,
                          supCode:this.userForm.supCode
                        }).then((res)=>{
                          console.log(res)
                          if(res.data.data === 'NO_SP0001') {
                            this.isShow1 = true
                            this.qrySupWhiteListBySupName(this.userForm.supplierName)
                            // callback(new Error(window.$t('page.applyUsername.inputRules.supNameMSg1'))) // 该供应商名称已存在
                          }  else if (res.data.data === 'RP_SP0001') {
                            this.isShow1 = true
                            this.promptType = res.data.data;
                            this.dialogPrompt = true;
                            this.qrySupWhiteListBySupName(this.userForm.supplierName)
                            // callback(new Error(window.$t('page.applyUsername.inputRules.supNameMSg1'))) // 该供应商名称已存在
                          } else if(res.data.data === "RP_SP0001_000001") {  // 针对于审批退回的供应商
                            this.promptType = res.data.data;
                            this.dialogPrompt = true;
                          } else if(['RP_SP0241','RP_SP0242','RP_SP0243', "RP_SP00074"].includes(res.data.data)){
                            callback(new Error(res.data.message))
                          } else {
                            this.isShow1 = false
                            callback()
                            this.qrySupWhiteListBySupName(this.userForm.supplierName)

                          }
                        })
                      },100)
                    }
                  },trigger: 'blur'}
              ]};
          }
        });
      }
    },
    ncData(ncData) {
      if (
        (!window.languagezh_cn && this.linkmanForm.email === "") ||
        (window.languagezh_cn && this.linkmanForm.userMobile.length != 11)
      ) {
        this.isEnabled++;
        if (!window.languagezh_cn) {
          this.$message.error(
            window.$t("page.applyUsername.inputPlc.contactsEmailMsg")
          );
        } else {
          this.$message.error(
            window.$t("page.applyUsername.inputPlc.contactsMobileMsg")
          );
        }
      } else {
        this.isEnabled = 0;
        this.codeDisabled = false;
      }
    },
    popDialogPay() {
      this.isRecommendedUnitTreeShow = true;
      this.dialogRecommendedUnitTree = true;
    },
    beforeClose() {
      this.isRecommendedUnitTreeShow = false;
      this.dialogRecommendedUnitTree = false;
    },
    closeDialog() {
      this.isRecommendedUnitTreeShow = false;
      this.dialogRecommendedUnitTree = false;
    },
    recommendedUnitLoadNode(node, resolve) {
      if (node.level === 0) {
        queryRecommendedUnitTree({
          parentPartyId: "100001"
        }).then(res => {
          res.data.data.forEach(e => {
            e.disabled = true;
          });
          resolve(res.data.data);
        });
      } else {
        queryRecommendedUnitTree({
          parentPartyId: node.data.partyId
        }).then(res => {
          res.data.data.forEach(e => {
            if (e.companyId === "100002") {
              e.disabled = true;
            }
            if (e.companyName == "中国交通建设股份有限公司") {
              e.disabled = true;
            }
          });
          resolve(res.data.data);
        });
      }
      if (node.level > 1) return resolve([]);
    },
    // 获取已选的节点
    getCheckedNodes(data, item) {
      // this.$nexTick(()=>{
      //   if (this.checkedFlag) {
      //     // 通过 keys 设置目前勾选的节点
      //     this.$refs.tree.setCheckedKeys([this.companyId]);
      //   } else {
      //     this.$refs.tree.setCheckedKeys([]);
      //   }
      // })
      if (item.checkedKeys.length == 2) {
        //单选实现
        this.$refs.tree.setCheckedKeys([data.companyId]);
      }
      this.companyId = data.companyId;
      this.linkmanForm.recommendIndyId = data.companyId;
      this.linkmanForm.recommendIndyCode = data.autoCode;
      this.linkmanForm.reCompany = data.companyName;
    },
    // 获取当前被选择的节点
    getCurrentNode(data, check) {
      this.checkedFlag = check;
    },
    confirmForm() {
      if (
        !this.linkmanForm.recommendIndyId ||
        !this.linkmanForm.recommendIndyCode ||
        !this.linkmanForm.reCompany
      ) {
        //弹出提示
        this.$message({
          showClose: true,
          type: "error",
          message: "请重新选择推荐单位",
          ccuiCustom: true,
          duration: 3000
        });
        return;
      }
      this.closeDialog();
    },
    // 联系人身份证校验
    validateIDCard() {
      if (this.linkmanForm.certType === 1) {
        !this.idCardIsMatched
          ? this.$message({
              showClose: true,
              type: "error",
              message: this.$t("page.validateMsg.validateIDCard1"),
              ccuiCustom: true,
              duration: 3000
            })
          : null;
        return this.idCardIsMatched;
      }
      return true;
    },
    async setUploadImageUrl(fileData, type) {
      this.$set(this.linkmanForm, type, fileData.ossUrl);
      this.fileInfoList[type === "positiveImageUrl" ? 0 : 1] = {
        fileUrl: fileData.ossUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileSumm: "",
        uploadTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId,
        positiveFlag: type === "positiveImageUrl" ? 1 : 2, // 1 正面 2 背面
        contactType: 1 // 1：注册联系人，2：法人, 3: 销售负责人
      };
      if (
        this.linkmanForm.positiveImageUrl &&
        this.linkmanForm.negativeImageUrl
      ) {
        try {
          const creditCode = this.isThreeShow && this.threeZ ? this.userForm.business : this.userForm.creditCode;
          const res = await qryIdCardByHwOcr({
            positiveImageUrl: this.linkmanForm.positiveImageUrl,
            negativeImageUrl: this.linkmanForm.negativeImageUrl,
            creditCode,
            contactType: "1",   // 联系人类型 1 -注册联系人，2-法人，3-销售负责人，4-常用联系人,5-董监高
          });
          const { idCardIsMatched, cardPersonBO } = res.data.data;
          this.idCardIsMatched = idCardIsMatched;
          if (idCardIsMatched) {
            this.linkmanForm.linkMan = cardPersonBO.name;
            this.linkmanForm.contactIdcard = cardPersonBO.idCard;
          }
        } catch (res) {
          this.idCardIsMatched = false;
        }
      }
    },
    certTypeChange(val) {
      if (val === 1) {
        this.linkmanForm.linkMan = "";
        this.linkmanForm.contactIdcard = "";
        this.$message({
          message: "上传身份证并校验通过后联系人信息和证件号自动带出",
          type: "warning",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
      if (val === 2) {
        this.linkmanForm.positiveImageUrl = "";
        this.linkmanForm.negativeImageUrl = "";
        this.linkmanForm.negtiveFileinfoId = "";
        this.linkmanForm.positiveFileinfoId = "";
        this.fileInfoList = [];
      }
    },


    // 2025-12-06 获取手机号验证码
    sendCode() {
      this.isSend = true;
      if (this.isChinese === 'zh-cn') {
        if (!this.userForm.supplierName) {
          this.$message.warning("供应商名称不能为空！");
          this.isSend = false;
          return;
        }
        if (this.userForm.isThree == 1 && !this.userForm.creditCode) {
          this.$message.warning("统一社会信用代码不能为空！");
          this.isSend = false;
          return;
        }
        if (!this.linkmanForm.userMobile) {
          this.$message.warning("联系人手机不能为空！");
          this.isSend = false;
          return;
        }
      } else {
        if (!this.userForm.contactMobile) {
          this.$message.warning("联系人手机不能为空！");
          this.isSend = false;
          return;
        }
      }
      this.isCode = true;
    },

    // 2025-12-11 获取Email验证码
    sendEmailCode() {
      this.isSendEmail = true;
      if (!this.userForm.supplierName) {
        // 供应商名称不能为空！ 2025-12-11
        this.$message.warning(this.$t("page.validateEmail.validateIDCard8"));
        this.isSendEmail = false;
        return;
      }
      if (!this.linkmanForm.email) {
        // 联系人邮箱不能为空 2025-12-11
        this.$message.warning(this.$t("page.validateEmail.validateIDCard7"));
        this.isSendEmail = false;
        return;
      }
      this.isCode = true;
    },
    
    // 获取滑动验证码的图片
    getImg(callback) {
      let that = this;
      getImageVerifyCode({}).then(
        res => {
          callback(res.data);
        },
        error => {
          that.isSend = false;
          that.isSendEmail = false;
          that.isCode = false;
          callback(error);
        }
      );
    },
    // 操作滑动后返回值，并传去后端验证
    validImg(blcokLeft, id, callback) {
      console.log(123444);
      // blcokLeft,// 手动定位返回的值
      //   id// 后台返回的id，再传回去
      this.handleLogin(blcokLeft, id, callback); // 登陆请求方法
    },
    
    handleLogin(blcokLeft, id, callback) {
      if(this.localLang === 'zh-cn') {
        this.isSend = true;
        sendVerificationCode({
          phoneNumbers: this.isChinese === "zh-cn"
            ? this.linkmanForm.userMobile
            : this.userForm.contactMobile,
          checkCodeLimitTime: blcokLeft,
          businessCode: id
        })
          .then(res => {
            if (res.data.code === "0") {
              callback({ data: true });
              this.isCode = false;
              this.$message({
                type: "success",
                message: res.data.message
              });
              let timer = setInterval(() => {
                if (this.countDown > 0) {
                  this.countDown--;
                  this.isSend = true;
                } else {
                  clearInterval(timer);
                  this.isSend = false; // 启用按钮
                  this.countDown = 120; // 重置倒计时时间
                }
              }, 1000);
              return false;
            } else {
              this.isSend = false;
              callback({ data: false, message: res.data.message });
              this.isCode = true;
            }
          })
          .catch(errMessage => {
            this.isSend = false;
          });
      } else {
        this.isSendEmail = true;
        // 获取Email验证码
        checkSendEmailCode({
          email: this.linkmanForm.email,
          checkCodeLimitTime: blcokLeft,
          businessCode: id
        }).then(res => {
            if (res.data.code === "0") {
              callback({ data: true });
              this.isCode = false;
              this.$message.success(
                "Email verification code sent successfully, please note receiving"
              );
              let timer = setInterval(() => {
                if (this.countDown > 0) {
                  this.countDown--;
                  this.isSendEmail = true;
                } else {
                  clearInterval(timer);
                  this.isSendEmail = false; // 启用按钮
                  this.countDown = 120; // 重置倒计时时间
                }
              }, 1000);
              return false;
            } else {
              this.isSendEmail = false;
              callback({ data: false, message: res.data.message });
              this.isCode = true;
            }
          })
          .catch(errMessage => {
            this.isSendEmail = false;
          });
      }
    },
    // 门户供应商注册提醒优化260119 改为弹框提示
    handleForgot() {
      // this.$message('跳转至密码找回页面');
      // 实际项目中可添加路由跳转：this.$router.push('/forgot-password')
      window.open(this.clickUrl, '_blank');
    },
    handleLoginOne() {
      // this.$message('跳转至登录页面');
      // 实际项目中可添加路由跳转：this.$router.push('/login')
      window.open(
        this.$addUrlPerFix(process.env.VUE_APP_LOGIN),
        '_blank'
      )
    },
    beforePromptClose() {
      this.promptType = "";
      this.dialogPrompt = false;
    }
  }
};
</script>

<style scoped lang="scss">
.endItem ::v-deep .el-input__inner {
  padding-right: 58px;
}
.sign-content {
  width: 1180px;
  background: #ffffff;
  margin: 20px auto;
  overflow: hidden;
  position: relative;
  .el-card-title {
    /deep/ .details-title {
      color: black;
      border-bottom: 0px;
      top: 20px;
    }
  }
  .card1 {
    margin-left: 245px;
  }
  .card2 {
    margin-left: 230px;
  }
  .card3 {
    margin-left: 288px;
    &.encard {
      margin-left: 230px;
    }
  }
  .el-form {
    margin-top: 20px;
    //margin-left: 295px;
    position: relative;
    .el-form-item {
      // color: rgba(208, 2, 27, 1);
      .el-col {
        .el-date-editor {
          width: 200px;
        }
      }
      .el-input {
        margin-left: 6px;
        width: 430px;
      }
      .format {
        font-size: 13px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
        line-height: 17px;
      }
      /deep/ .el-form-item__label {
        padding: 1px 2px 0 0;
        font-size: 13px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(74, 74, 74, 1);
      }
      .el-form-item__content {
        margin-left: 90px;
      }
    }
    .el-cascader {
      margin-left: 6px;
      width: 430px;
    }
    .el-radio-group {
      margin-left: 6px;
    }
    .reCompany {
      margin-top: 20px;
    }
  }
  .grouptips {
    width: 340px;
    height: 18px;
    font-size: 13px;
    color: #999;
    font-weight: 400;
    position: absolute;
    top: -38px;
    left: 357px;
    white-space: nowrap;
  }
  .grouptips_en {
    height: 18px;
    font-size: 13px;
    color: #999;
    font-weight: 400;
    //position: absolute;
    //top: -38px;
    //left: 544px;
    white-space: normal;
    margin-bottom: 15px;
    margin-left: 230px;
  }
  .validity .el-col-2 {
    position: absolute;
    left: 220px;
  }
  .validity .el-col-5:nth-child(3) {
    margin-left: 68px;
  }
  .validity .el-date-editor {
    width: 200px;
    /deep/ .el-input__inner {
      width: 200px;
    }
  }
  .authCode {
    position: relative;
    .el-button {
      position: absolute;
      top: 0px;
      left: 450px;
      width: 85px;
      &.enBtn {
        width: 185px;
      }
    }
  }
  .el-autocomplete {
    width: 430px;
    margin-left: 6px;
  }
  .el-block {
    position: absolute;
    top: 30px;
    width: 388px;
    margin-right: 42px;
    height: 30px;
    margin-left: 6px;
    .slideText1 {
      position: absolute;
      z-index: 999;
      left: 138px;
      top: 15px;
    }
    .slideText2 {
      position: absolute;
      z-index: 999;
      left: 188px;
      top: 15px;
      color: #fff;
    }
    .el-block-replace {
      position: absolute;
      width: 42px;
      height: 30px;
      background: #f1f1f1;
      border-radius: 0 3px 3px 0;
      top: 16px;
      right: -42px;
    }
  }
  /deep/ .el-slider {
    .el-slider__runway {
      height: 30px;
      margin-bottom: 15px;
      border-radius: 3px 0 0 3px;
      background-color: #f1f1f1;
      .el-slider__button {
        margin-left: 19px;
        margin-top: 15px;
        width: 40px;
        height: 26px;
        border-radius: 0;
        border: 2px solid #f1f1f1;
      }
      .el-slider__button-wrapper .el-slider__button:hover {
        transform: scale(1);
      }
      .el-slider__bar {
        height: 29px;
        background-color: #00954c;
      }
    }
  }
  /deep/.el-form-item {
    height: 41px;
  }
  .recommendUnitGroup {
    position: relative;
    .reCompanyTitle {
      position: absolute;
      top: 20px;
      left: 357px;
      font-size: 13px;
      color: #999;
    }
    .reCompanyTitle_en {
      //position: absolute;
      //top: 416px;
      //left: 250px;
      //font-size: 13px;
      //color: #FF142F;

      height: 18px;
      font-size: 13px;
      color: #999;
      font-weight: 400;
      margin-top: 20px;
      white-space: normal;
      margin-bottom: 15px;
      margin-left: 230px;
    }
  }
}
.btn {
  width: 240px;
  height: 40px;
  background: #ff142f;
  margin-bottom: 20px;
  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
  }
}
.btnBox {
  margin: 0px auto;
  width: 500px;
}
.disSlide {
  pointer-events: none;
}
/deep/.IDplac input {
  padding-right: 45px;
}
/deep/.enForm {
  height: 496px !important;
}
/deep/.GATcreditCode input {
  padding-right: 50px;
}



//滑动窗样式
.islider {
  width: 400px;
  height: 265px;
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 6px 0px rgba(201, 201, 201, 0.5),
    4px 0px 4px 0px rgba(229, 229, 229, 0.5);
  position: absolute;
  top: -278px;
  left: 15px;
}
.islider::before {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid rgba(0, 0, 0, 0.1);
}
.islider::after {
  position: absolute;
  bottom: -11px;
  left: 50%;
  content: "";
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  border-top: 11px solid #ffffff;
  filter: drop-shadow(1px 3px 1px rgba(0, 0, 0, 0.2));
}



.prompt {
  /deep/ .el-dialog__header {
    border-bottom: none !important;
  }
  /deep/ .el-dialog__footer {
    border-top: none !important;
  }
  .dialog-content {
    text-align: center;
    padding: 10px 10px 20px 10px;
  }
  .title {
    font-size: 18px;
    margin-bottom: 15px;
  }
  .desc {
    color: #606266;
    line-height: 1.5;
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    gap: 40px;
  }
}

/deep/.egcnName>.el-input__inner{
  padding-right: 51px !important;
}
</style>
<style>
.el-cascader-panel .el-radio {
  width: 100% !important;
  height: 100% !important;
  z-index: 10 !important;
  position: absolute !important;
  top: 10px !important;
  right: 10px !important;
}
.el-cascader-panel .el-radio__input {
  visibility: hidden !important;
}
.el-cascader-panel .el-cascader-node__postfix {
  top: 10px !important;
}
</style>
